// Components==============
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import Button from 'components/UI/Button/Button';
import React, { useContext } from 'react';
import updateAssessment from 'actions/assessment/update';
import { useRedux } from 'hooks/useRedux';
import { useDispatch } from 'react-redux';
import { useConfirm } from 'hooks/useConfirm';
import { useHistory } from 'react-router';
import { AssessmentContext } from '../../Feedback';
import MemberBar from './MemberBar/MemberBar';
import ToggleAllButton from './ToggleAllButton';
import './Top.module.scss';
// =========================

export default function Top() {
  const { wrapperRef, assessment, isTeacher } = useContext(AssessmentContext);

  const history = useHistory();
  const confirm = useConfirm();
  const dispatch = useDispatch();
  const userId = useRedux((state) => state.authentication?.user?.id);
  const isFirst = assessment?.first_assessor_id === userId;
  const isViewOnly =
    assessment?.first_assessor_done === 1 &&
    assessment?.second_assessor_done === 1;

  const handleSave = () => {
    confirm(
      isFirst
        ? 'Weet je zeker dat je deze student definitief wil beoordelen? Als de tweede beoordelaar jouw beoordeling heeft gevalideerd wordt het zichtbaar voor de student. Na het versturen is wijzigen niet meer mogelijk.'
        : 'Weet je zeker dat je de beoordeling wil versturen? Dit kan niet ongedaan worden gemaakt en je beoordeling is meteen zichtbaar voor de student en eerste beoordelaar.',
      () => {
        dispatch(
          updateAssessment(
            isFirst
              ? { ...assessment, markAsDone: 1, first_assessor_done: 1 }
              : { ...assessment, markAsDone: 1, second_assessor_done: 1 }
          )
        ).then(() => {
          history.push('/groei/beoordelen');
        });
      }
    );
  };
  return (
    <div styleName="wrapper">
      <div styleName="user">
        <MemberBar
          question={
            assessment?.project?.process[0]?.description?.design_question
          }
          user={assessment?.student}
        />
      </div>
      {isTeacher && (
        <div styleName="right-buttons">
          <ArrowButtons color="white" reference={wrapperRef} />
          <ToggleAllButton />
          {!isViewOnly && (
            <Button onClick={handleSave}>
              Beoordeling definitief versturen
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
